<template>

<div>
  <div class="header-container pb-2">
    <h2>Gestión de Clientes</h2>
    <form @submit.prevent="filterClients" class="filter-form">
      <div class="form-group">
        <label>Identificador
          <b-form-input v-model="filters.codeId"/>
        </label>
      </div>
      <div class="form-group">
        <label>Denominación
          <b-form-input v-model="filters.name"/>
        </label>
      </div>
      <div class="form-group">
        <label>Estado
          <b-form-select v-model="filters.status" :options="statusOptions"/>
        </label>
      </div>
      <div>
        <b-button type="submit" variant="primary">Buscar</b-button>
      </div>
    </form>
    <div class="d-flex justify-content-center">
      <b-pagination class="ml-auto" v-model.number="paginator.page" @change="onPageChange"
                    :per-page="paginator.perPage" :total-rows="paginator.totalElements"/>
      <div class="pr-4 ml-auto">
        <b-button :disabled="!canCreate" v-b-modal.addClientModal variant="success">Nuevo Cliente</b-button>
      </div>
    </div>
  </div>
  <div class="fixed-table-container">
    <b-table striped :items="paginator.content" :fields="fields" no-local-sorting @sort-changed="sortClients">
      <template slot="buttons" slot-scope="data">
        <b-button :disabled="!canUpdate" @click="openEditModal(data.item)" size="sm" variant="primary"><fa-icon icon="edit"/></b-button>
        <b-button :disabled="!canDelete" @click="deleteCliente(data.item)" variant="danger" size="sm"><fa-icon icon="trash-alt"/></b-button>
      </template>
    </b-table>
  </div>
  <add-client-modal modal-id="addClientModal" @save="createClient"/>
  <edit-client-modal ref="editModal" @save="updateClient"/>
  <b-modal ref="deleteDialog" title="¿Está Seguro?" ok-title="Eliminar" cancel-title="Cancelar"
           ok-variant="danger" header-bg-variant="danger" header-text-variant="light">
    <p>¿Está seguro de que desea eliminar el cliente?</p>
  </b-modal>
</div>

</template>

<script>

import api from '@/api/api'
import AddClientModal from './AddClientModal'
import EditClientModal from './EditClientModal'
import {session} from '@/auth'

export default {
  name: 'ClientIndex',
  components: {
    AddClientModal,
    EditClientModal
  },
  created() {
    this.loadClients(1)
  },
  data() {
    return {
      session,
      paginator: {
        page: 1,
        perPage: 10,
        totalElements: 0,
        content: []
      },
      sort: null,
      fields: [
        {key: 'codeId', label: 'Identificador', sortable: true},
        {key: 'name', label: 'Denominación', sortable: true},
        {key: 'status', label: 'Estado', sortable: true, formatter: v => this.getStatusLabel(v)},
        {key: 'buttons', label: 'Gestión'}
      ],
      filters: {
        codeId: null,
        name: null,
        status: null
      },
      statusOptions: [
        {text: 'Todos', value: null},
        {text: 'Activo', value: 'ACTIVATED'},
        {text: 'Baja', value: 'DEACTIVATED'}
      ]
    }
  },
  computed: {
    canCreate() {
      return this.session.authorities.includes('ROLE_CLIENT_CREATE')
    },
    canUpdate() {
      return this.session.authorities.includes('ROLE_CLIENT_UPDATE')
    },
    canDelete() {
      return this.session.authorities.includes('ROLE_CLIENT_DELETE')
    }
  },
  methods: {
    getStatusLabel(value) {
      return this.statusOptions.find(i => i.value === value).text || null
    },
    openEditModal(client) {
      this.$refs.editModal.show(client)
    },
    onPageChange(page) {
      this.loadClients(page)
    },
    filterClients() {
      this.loadClients(1)
    },
    sortClients(context) {
      this.sort = context.sortBy && context.sortBy + ',' + (context.sortDesc ? 'desc' : 'asc')
      this.loadClients(1)
    },
    loadClients(page = this.paginator.page) {
      const params = {page: page - 1, size: this.paginator.perPage, sort: this.sort, ...this.filters}
      api.client.index(params).then(paginator => {
        this.paginator.content = paginator.content
        this.paginator.totalElements = paginator.totalElements
        this.paginator.page = page
      })
    },
    createClient(client) {
      api.client.create(client).then(() => {
        this.loadClients(1)
        this.$toastr('success', 'Cliente Creado')
      })
    },
    updateClient(client) {
      api.client.update(client).then(() => {
        this.loadClients()
        this.$toastr('success', 'Cliente Editado')
      })
    },
    deleteCliente(cliente) {
      this.$refs.deleteDialog.$off('ok') // very important. clear previous custom event listeners
      this.$refs.deleteDialog.$once('ok', () => {
        api.client.delete(cliente.id).then(() => {
          this.loadClients().then(() => this.$toastr('success', 'Cliente Eliminado'))
        })
      })
      this.$refs.deleteDialog.show()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/client/Index.vue